import { AppState } from "@shared/interfaces";
import { createSelector } from "reselect";

const selectPatient = (state: AppState) => state.patient;

export const getPatients = () => createSelector(selectPatient, (state) => state.patients);
export const getPatient = () => createSelector(selectPatient, (state) => state.patient);
export const getPatientsTotal = () => createSelector(selectPatient, (state) => state.patientsTotal);
export const getFilter = () => createSelector(selectPatient, (state) => state.filter);

export const getDetailedChartFilter = () => createSelector(selectPatient, (state) => state.detailedChartFilter);
export const getDetailedChartValues = () => createSelector(selectPatient, (state) => state.detailedChartValues);

export const getDailyChartFilter = () => createSelector(selectPatient, (state) => state.dailyChartFilter);
export const getDailyChartValues = () => createSelector(selectPatient, (state) => state.dailyChartValues);
export const getDailyChartNotifications = () => createSelector(selectPatient, (state) => state.dailyChartNotifications);
export const getPatientsImportResults = () => createSelector(selectPatient, (state) => state.importPatientsResults);
